module.exports = __webpack_public_path__ + "media/images/amenities_icons/scanner-d06eea00291b1bde3d83b7a6c908c3e0.svg";